export default __webpack_public_path__ + "static/media/grid_icon.f29d2cd3.svg";